import React from 'react';
import { FileText, ArrowRight, FileCheck2 } from 'lucide-react';

interface DocumentsDashboardProps {
  onOpenDocument: (docId: string) => void;
}

export const DocumentsDashboard: React.FC<DocumentsDashboardProps> = ({ onOpenDocument }) => {
  return (
    <div className="max-w-6xl mx-auto p-8">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 bg-black rounded-xl flex items-center justify-center text-white">
          <FileCheck2 size={24} />
        </div>
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">Documentos Oficiais</h1>
          <p className="text-gray-500 mt-1 text-lg">Gerencie propostas, relatórios e documentos da agência</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Card: Assinatura do Combo */}
        <div 
          onClick={() => onOpenDocument('proposta_assinatura_1000')}
          className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-lg hover:border-blue-500 transition-all cursor-pointer group flex flex-col"
        >
          <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-600 group-hover:text-white transition-colors">
            <FileText size={24} />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Proposta: Assinatura Combo</h3>
          <p className="text-gray-500 mb-8 flex-1">
            Proposta oficial NYROH de R$ 1.000/mês para fechamento de sistema integrado de aquisição e atendimento (Tráfego, Conteúdo, Site e IA).
          </p>
          <div className="flex items-center text-blue-600 font-semibold group-hover:underline">
            Abrir Documento <ArrowRight size={18} className="ml-2" />
          </div>
        </div>
      </div>
    </div>
  );
};
